module.exports = __webpack_public_path__ + "static/media/p_14_4.158e1235.png";